module.exports = __webpack_public_path__ + "img/benoit6.909e015d.jpg";